import blacklist from '../searchTermBlacklist.json' with { type: 'json' };

const blacklistedTerms = new Set(
  blacklist.terms.map((term: string) => term.toLowerCase())
);

export function isSearchTermBlacklisted(query: string): boolean {
  const normalizedQuery = query.toLowerCase();

  return Array.from(blacklistedTerms).some((term) =>
    normalizedQuery.includes(term)
  );
}
